import { ReactComponent as ArrowIcon } from 'assets/icons/arrow.svg';
import { ReactComponent as CursorIcon } from 'assets/icons/cursor.svg';
import { ReactComponent as LineIcon } from 'assets/icons/line.svg';
import { ReactComponent as MarkerIcon } from 'assets/icons/pen.svg';
import { ReactComponent as PancilIcon } from 'assets/icons/pencil3.svg';
import { ReactComponent as CircleIcon } from 'assets/icons/shapeCircle.svg';
import { ReactComponent as RectangleIcon } from 'assets/icons/shapeRect.svg';
import { ReactComponent as TextIcon } from 'assets/icons/text-icon.svg';
import TooltipNew from 'components/common/TooltipNew/TooltipNew';
import { useTranslation } from 'react-i18next';

import style from './Editor.module.scss';
import MenuItemDropdown from './MenuItemDropdown';

const ToolSelection = ({ tool, onClick }) => {
  const { t } = useTranslation();
  const getActiveConnectingTool = () => {
    if (tool === 'arrow') return <ArrowIcon />;
    return <LineIcon />;
  };
  const getActiveShape = () => {
    switch (tool) {
      case 'ellipse':
        return <CircleIcon />;
      default:
        return <RectangleIcon />;
    }
  };

  return (
    <div className={style.menu}>
      <TooltipNew tooltip={t('aireview:selection_tool')}>
        <button
          className={`${style.button} ${tool === 'select' && style.active}`}
          onClick={() => {
            onClick('select');
          }}
        >
          <CursorIcon />
        </button>
      </TooltipNew>
      <TooltipNew tooltip={t('aireview:edit_text')}>
        <button
          className={`${style.button} ${tool === 'text' && style.active}`}
          onClick={() => {
            onClick('text');
          }}
        >
          <TextIcon />
        </button>
      </TooltipNew>

      <MenuItemDropdown
        type="light"
        tooltip={t('aireview:drawing_tools')}
        closeOnClick={true}
        trigger={
          <div className={` ${['marker', 'pen'].indexOf(tool) > -1 && style.active}`}>
            {tool !== 'pen' && <MarkerIcon />}
            {tool === 'pen' && <PancilIcon />}
          </div>
        }
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <TooltipNew tooltip={t('aireview:marker')}>
            <button
              className={`${style.button} ${tool === 'marker' && style.active}`}
              onClick={() => {
                onClick('marker');
              }}
            >
              <MarkerIcon />
            </button>
          </TooltipNew>

          <TooltipNew tooltip={t('aireview:pencil')}>
            <button
              className={`${style.button} ${tool === 'pen' && style.active}`}
              onClick={() => {
                onClick('pen');
              }}
            >
              <PancilIcon />
            </button>
          </TooltipNew>
        </div>
      </MenuItemDropdown>
      <MenuItemDropdown
        tooltip={t('aireview:connecting_tools')}
        closeOnClick={true}
        type="light"
        trigger={getActiveConnectingTool()}
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <TooltipNew tooltip={t('aireview:line')}>
            <button
              className={`${style.button} ${tool === 'line' && style.active}`}
              onClick={() => {
                onClick('line');
              }}
            >
              <LineIcon />
            </button>
          </TooltipNew>
          <TooltipNew tooltip={t('aireview:arrow')}>
            <button
              className={`${style.button} ${tool === 'arrow' && style.active}`}
              onClick={() => {
                onClick('arrow');
              }}
            >
              <ArrowIcon />
            </button>
          </TooltipNew>
        </div>
      </MenuItemDropdown>

      <MenuItemDropdown
        closeOnClick={true}
        tooltip={t('aireview:shapes')}
        type="light"
        trigger={getActiveShape()}
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <TooltipNew tooltip={t('aireview:rectangle')}>
            <button
              className={`${style.button} ${tool === 'rect' && style.active}`}
              onClick={() => {
                onClick('rect');
              }}
            >
              <RectangleIcon />
            </button>
          </TooltipNew>
          <TooltipNew tooltip={t('aireview:ellipse')}>
            <button
              className={`${style.button} ${tool === 'ellipse' && style.active}`}
              onClick={() => {
                onClick('ellipse');
              }}
            >
              <CircleIcon />
            </button>
          </TooltipNew>
        </div>
      </MenuItemDropdown>
    </div>
  );
};

export default ToolSelection;
